// extracted by mini-css-extract-plugin
module.exports = {"tableBodyInfo":"TableBody__tableBodyInfo--3hO","tableBodyEmpty":"TableBody__tableBodyEmpty--2GT"};